import { attr, customElement, FASTElement, observable } from '@microsoft/fast-element';
import { MultiSegmentedControlTemplate as template } from './multi-segmented-control.template';
import { MultiSegmentedControlStyles as styles } from './multi-segmented-control.styles';

const name = 'multi-segmented-control';

@customElement({
  name,
  template,
  styles,
})
export class MultiSegmentedControl extends FASTElement {
  @attr @observable hideControl: string = 'false';
  @observable options: string[] = [];
  @attr @observable selectedOptions: string[];

  public onChange(value: string) {
    if (!this.selectedOptions) {
      this.selectedOptions = [];
    }
    const index = this.selectedOptions.findIndex((element) => element === value);
    if (index !== -1) {
      this.selectedOptions.splice(index, 1);
    } else {
      this.selectedOptions.push(value);
    }
    this.$emit('selectionChange', this.selectedOptions);
  }
}
